import startCase from 'lodash/startCase';
import { useMemo, useState } from 'react';
import { useAppSelector } from './useAppStore';
import { getPlatformData } from '../store/common/selectors';

export function usePlatformData() {
  const platformData = useAppSelector(getPlatformData);

  const locationsMapIdToName = useMemo(() => platformData.locations?.reduce((acc: { [key: number]: string }, location) => {
    acc[location.id] = location.name;

    return acc;
  }, {}), [platformData?.locations]);

  const [departments, setDepartments] = useState({
    newDepartments: [] as Array<string>,
    oldDepartments: platformData?.departments,
  });
  const [positions, setPositions] = useState({
    newPositions: [] as Array<string>,
    oldPositions: platformData?.positions,
  });

  const addNewDepartment = (department: string) => {
    setDepartments((prevState) => ({
      ...prevState,
      newDepartments: [...prevState.newDepartments, startCase(department)],
    }));
  };

  const addNewPosition = (position: string) => {
    setPositions((prevState) => ({
      ...prevState,
      newPositions: [...prevState.newPositions, startCase(position)],
    }));
  };

  const getDepartments = useMemo(() => [...(departments?.oldDepartments || []), ...(departments?.newDepartments || [])], [departments]);
  const getPositions = useMemo(() => [...(positions?.oldPositions || []), ...(positions?.newPositions || [])], [positions]);

  const deleteDepartment = (department: string) => {
    if (departments.newDepartments.includes(department)) {
      setDepartments((prevState) => ({
        ...prevState,
        newDepartments: prevState.newDepartments.filter((item) => item !== department),
      }));
    } else {
      setDepartments((prevState) => ({
        ...prevState,
        oldDepartments: prevState.oldDepartments.filter((item) => item !== department),
      }));
    }
  };

  const deletePosition = (position: string) => {
    if (positions.newPositions.includes(position)) {
      setPositions((prevState) => ({
        ...prevState,
        newPositions: prevState.newPositions.filter((item) => item !== position),
      }));
    } else {
      setPositions((prevState) => ({
        ...prevState,
        oldPositions: prevState.oldPositions.filter((item) => item !== position),
      }));
    }
  };

  return {
    addNewPosition,
    addNewDepartment,
    deleteDepartment,
    deletePosition,
    getDepartments,
    getPositions,
    locationsMapIdToName,
  };
}
